import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Availability } from '../../entities/Availability';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { apiRequests } from '../../shared/api/apiRequests';
import { toast } from 'react-toastify';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateIndustryPage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    title: '',
    mainLanguageId: 1,
    availability: {
      availableInAllCountries: true,
      allowedCountriesIds: [],
      disallowedCountriesIds: [],
    },
  });

  const handleSubmit = async () => {
    if (!form.title.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      await apiRequests.portfolio.createIndustry(form);
      toast.success('Индустрия создана');
      navigate('/portfolio/industries');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/portfolio/industries')} saving={saving} submitText="Создать">
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Название" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} />
            </FormField>
          </Col>
          <Col md={6}>
            <LanguageOptions onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))} />
          </Col>
        </Row>
      </FormSection>
      <FormSection title="Доступность">
        <Availability
          onSelect={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, availableInAllCountries: val } }))}
          onSelectAllowed={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, allowedCountriesIds: val } }))}
          onSelectDisallowed={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, disallowedCountriesIds: val } }))}
        />
      </FormSection>
    </FormLayout>
  );
};

export default CreateIndustryPage;
